export default "__VITE_ASSET__DQECqhk2__"